<app-wizard-bar-nav> </app-wizard-bar-nav>

<form [formGroup]="frmGetQuote">
  <h2 *ngIf="originalQuoteRequestId">Renewing Quote {{ originalQuoteRequestId }}</h2>

  <app-quote-note></app-quote-note>

  <div class="container flex borderBottom">
    <div id="title">
      <h3 id="title">
        Get Quote |
        <app-company-quoteid-header [quote]="quoteRequestState"></app-company-quoteid-header>
      </h3>
    </div>
    <app-quote-review-actions id="rejectAllButtonDiv"></app-quote-review-actions>
  </div>

  <section class="quote-fields">
    <div class="left">
      <mat-form-field appearance="standard" floatLabel="always">
        <mat-label>Broker Fee (Mills/{{ utilityUOM$ | async | lowercase }})</mat-label>
        <input
          id="uplift"
          matInput
          type="number"
          formControlName="upliftDollar"
          (selectedValueChange)="this.frmGetQuote.updateValueAndValidity()"
          [disabled]="isButtonQuoteDisabled"
        />
        <mat-error *ngIf="'isFormInvalid()'">Please enter a value between {{ this.upliftMin }} and {{ this.upliftMax }} </mat-error>
      </mat-form-field>

      <span id="gasDollarsPerDekatherm" *ngIf="isGasQuote()" class="upliftMarginMwhLabel"
        >${{ frmGetQuote?.get('upliftDollar')?.value / 100 | number: '1.2-4' }}/{{
          (utilityUOM$ | async) === 'therms' ? 'dekatherm' : 'Mcf'
        }}</span
      >

      <span id="electricDollarsPerMwh" *ngIf="!isGasQuote()" class="upliftMarginMwhLabel"
        >${{ frmGetQuote?.get('upliftDollar')?.value | number: '1.2-4' }}/MWh</span
      >
      <div></div>

      <div *ngIf="user.hasRole(UserRole.SupplierManager) && pricingSource !== PricingSourceEnum.ManualEntry">
        <mat-form-field *ngIf="pricingSource == PricingSourceEnum.Dynamic" appearance="standard" floatLabel="always">
          <mat-label>Margin (Mills/{{ utilityUOM$ | async | lowercase }})</mat-label>
          <input
            matInput
            (blur)="marginDollarChanges($event?.target?.value)"
            type="number"
            formControlName="marginDollar"
            [disabled]="isButtonQuoteDisabled"
          />
        </mat-form-field>
        <mat-form-field *ngIf="pricingSource == PricingSourceEnum.SupplierMatrix" appearance="standard" floatLabel="always">
          <mat-label>Margin (Mills/{{ utilityUOM$ | async | lowercase }})</mat-label>
          <input matInput type="number" formControlName="marginDollar" [disabled]="isButtonQuoteDisabled" />
        </mat-form-field>
        <span id="marginDollarsPerMwh" *ngIf="!isGasQuote()" class="upliftMarginMwhLabel">
          ${{ frmGetQuote?.get('marginDollar')?.value | number: '1.2-4' }}/MWh</span
        >
        <span id="marginDollarsPerDekatherm" *ngIf="isGasQuote()" class="upliftMarginMwhLabel"
          >${{ frmGetQuote?.get('marginDollar')?.value / 100 | number: '1.2-4' }}/{{
            (utilityUOM$ | async) === 'therms' ? 'dekatherm' : 'Mcf'
          }}</span
        >
      </div>
      <div *ngIf="isPowwrSupplier">
        <mat-radio-group
          [disabled]="isButtonQuoteDisabled"
          formControlName="isTaxIncluded"
          floatLabel="always"
          appearance="standard"
          id="isTaxIncluded"
        >
          <mat-radio-button [value]="true">Include Tax </mat-radio-button>
          <mat-radio-button [value]="false">Exclude Tax </mat-radio-button>
        </mat-radio-group>
      </div>
      <br />

      <div *ngIf="user.hasRole(UserRole.SupplierManager)">
        <button
          id="quoteBtn"
          mat-flat-button
          color="accent"
          type="button"
          (click)="getQuote()"
          [disabled]="this.isQuoteButtonDisabled() === false ? isButtonQuoteDisabled : this.isQuoteButtonDisabled()"
        >
          <img src="/assets/icons/icon-money.svg" class="prefix" />
          <span>{{ quote?.prices?.length > 0 ? 'Requote' : 'Quote' }}</span>
        </button>
      </div>
      <div *ngIf="user.hasRole(UserRole.SupplierManager) == false">
        <button
          id="quoteBtn"
          mat-flat-button
          color="accent"
          type="button"
          (click)="getQuoteDueDateUpdate()"
          [disabled]="this.isQuoteButtonDisabled() === false ? isButtonQuoteDisabled : this.isQuoteButtonDisabled()"
        >
          <img src="/assets/icons/icon-money.svg" class="prefix" />
          <span>{{ quote?.prices?.length > 0 ? 'Requote' : 'Quote' }}</span>
        </button>
      </div>

      <ng-content select="[quoteSettings]"></ng-content>
    </div>

    <div class="right">
      <a (click)="showMoreOrLess(!moreDetails)">
        <ng-container *ngIf="moreDetails; else elseTemplate"> Show Less </ng-container>
        <ng-template #elseTemplate> Show More </ng-template>
      </a>
      <div *ngIf="isPowwrSupplier && isSupplierManager() && this.quote?.prices[0]?.details" id="curveDate">
        Pricing Curve Date - {{ this.pricingCurveDateObs | async | date: 'MM/dd/yyyy' }}
      </div>
      <div id="loadFactor" *ngIf="this.quote?.prices[0]?.details">
        <!-- 'Annual Load Factor: {{ this.annualLoadFactorObs | async | number: '1.0' }}%' -->
      </div>
    </div>
  </section>

  <app-offer-filters *ngIf="moreDetails" [contractLengths]="this.contractLengths"> </app-offer-filters>

  <app-quote-status-message></app-quote-status-message>

  <div class="btnCenter" *ngIf="this.showRequestAQuoteButton()">
    <button id="requestAQuoteBtn" mat-flat-button color="accent" type="button">
      <img src="/assets/icons/icon-money.svg" class="prefix" />
      Request a Quote
    </button>
  </div>

  <app-quote-results
    *ngIf="this.quoteStatus !== 'QuoteExpired' && !this.quotationDeactivationCheckerService.IsQuotationDisabledForTheDay"
    
    (offersActioned)="onAcceptOrRejectOffer($event)"
    [allMarginChanged]="this.isAllMarginChanged"
  >
  </app-quote-results>
</form>
